/**
 * Single source of truth for the backend API base URL.
 *
 * Centralised here per the Feb-26 audit (P1.1 — hoist API constant). Files
 * previously declared `const API = ...` 95+ times; now they import this.
 *
 * The trailing /api is included so callers can simply write `${API}/users`
 * or `axios.get(`${API}/users`)`.
 */
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Convenience for places that want the raw backend URL (websockets etc.)
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default API;
